import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // BrowserRouter burada tanımlı
import { Provider } from "react-redux"; // Redux Provider import
import App from "./App";
import "./assets/css/main.css";
import Layout from "./components/layout/Layout";
import JWTProvider from "./context/jwtContext";
import store from "./store/store"; // Redux store'u içeren dosyanızı import edin
import { ToastContainer } from "react-toastify";
import { SettingsProvider } from './components/settings';
import { defaultSettings } from "./components/settings";
import InitColorSchemeScript from '@mui/material/InitColorSchemeScript';
import { ThemeProvider, themeConfig } from "./theme";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <JWTProvider>
      <InitColorSchemeScript
          defaultMode={themeConfig.defaultMode}
          modeStorageKey={themeConfig.modeStorageKey}
          attribute={themeConfig.cssVariables.colorSchemeSelector}
        />
      <SettingsProvider defaultSettings={defaultSettings}>
        <ThemeProvider>
          <BrowserRouter> {/* BrowserRouter burada tanımlı */}
            <Layout>
              <App />
            </Layout>
            <ToastContainer />
          </BrowserRouter>
        </ThemeProvider>
        </SettingsProvider>
      </JWTProvider>
    </Provider>
  </React.StrictMode>
);
